// import {
//     Box, Button, Grid,
//     InputAdornment,
//     // Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
//     TextField, Typography
// } from '@mui/material'
// import React, { useContext, useRef, useState } from 'react'
// import { DataGrid } from '@mui/x-data-grid'
// import { useEffect } from 'react'
// import User from '../services/db/user'
// import objToXlsx from '../utils/objToXlsx'
// import htmlToPdf from '../utils/htmlToPdf'
// import { InfoContext } from '../services/Context/Info/context'
// import {  Search } from '@mui/icons-material'
// import search from '../utils/searchEngine'
// import { Link } from 'react-router-dom'


// function formatFirestoreDate(timestamp) {

//     console.log('timestamp', timestamp)
//     const date = timestamp.toDate(); // Firestore Timestamp -> JS Date

//     console.log('date', date)
//     const dd = String(date.getDate()).padStart(2, '0');
//     const mm = String(date.getMonth() + 1).padStart(2, '0');
//     const yy = String(date.getFullYear()).slice(-2);
//     return `${dd}-${mm}-${yy}`; // 👈 dd first now
//   }
  
//   const columns = [
//     { field: 'displayName', headerName: 'Name', width: 150 },
//     { field: 'displayName', headerName: 'User Name', width: 150 },
//     {
//       field: 'createdAt',
//       headerName: 'Date Register',
//       width: 150,
//       valueGetter: (params) => {
//         if (!params.row.createdAt) return '';
//         return formatFirestoreDate(params.row.createdAt);
//       }
//     },
//     { field: 'email', headerName: 'Email id', width: 250 },
//     { field: 'phoneNumber', headerName: 'Contact Number', width: 150 },
//     { field: 'category', headerName: 'Services', width: 150 },
//     {
//       field: 'action',
//       headerName: 'Action',
//       renderCell: ({ row }) => {
//         console.log("log", row);
//         return (
//           <Button
//             size='small'
//             variant='contained'
//             LinkComponent={Link}
//             to={`/service-provider/${row.phoneNumber}_${row.role}_${row.uid}`}
//           >
//             View
//           </Button>
//         );
//       }
//     },
//   ];


// const ServiceProvider = () => {
//     const pdfRef = useRef(null)
//     const [searchQuery, setsearchQuery] = useState();
//     const { data: { serviceProviderData }, setData } = useContext(InfoContext);


//     console.log('serviceProviderData', serviceProviderData)
//     useEffect(() => {
//         if (!serviceProviderData.length) new User().allServiceProviders().then(r => {
//             // console.log("datadata" , r)
//             setData(p => ({ ...p, serviceProviderData: r }))
//         })
//     }, []);

//     const searchData = search(searchQuery, serviceProviderData, ['displayName', 'email', 'phoneNumber'])



//     console.log('searchData', searchData)
//     const getRowSpacing = React.useCallback((params) => {
//         return {
//             top: params.isFirstVisible ? 0 : 5,
//             bottom: params.isLastVisible ? 0 : 5,
//         };
//     }, []);

//     const commonButtonProps = { variant: 'contained', size: 'medium', color: 'primary', fullWidth: true }
//     return (
//         <Box sx={{ paddingX: 5, height: '100%' }}>
//             <Grid container direction='column' paddingTop={2} spacing={5} minHeight='100%'>
//                 <Grid item xs={12} paddingY={1}>
//                     <Typography>Service Provider</Typography>
//                 </Grid>
//                 <Grid item container xs={12} spacing={2}>
//                     <Grid item container xs={9} spacing={2}>
//                         <Grid item xs={12} container spacing={1}>
//                             {/* <Grid item xs={3}>
//                                 <Button {...commonButtonProps}>Active</Button>
//                             </Grid>
//                             <Grid item xs={3}>
//                                 <Button {...commonButtonProps}>Banned</Button>
//                             </Grid>
//                             <Grid item xs={3}>
//                                 <Button {...commonButtonProps}>Pending</Button>
//                             </Grid> */}
//                             {/* <Grid item xs={3}>
//                                 <Button {...commonButtonProps}>Sign Up Only</Button>
//                             </Grid> */}
//                         </Grid>
//                         <Grid item xs={12} container spacing={1}>
//                             <Grid item xs={3}>
//                                 <Button
//                                     onClick={() => objToXlsx(serviceProviderData, 'serviceProvider')}
//                                     {...commonButtonProps}
//                                 >
//                                     Excel
//                                 </Button>
//                             </Grid>
//                             <Grid item xs={3}>
//                                 <Button
//                                     onClick={() => htmlToPdf(pdfRef.current, 'serviceProvider', "save")}
//                                     {...commonButtonProps}
//                                 >
//                                     PDF
//                                 </Button>
//                             </Grid>
//                             <Grid item xs={3}>
//                                 <Button
//                                     onClick={() => htmlToPdf(pdfRef.current, 'serviceProvider', "view")}
//                                     {...commonButtonProps}
//                                 >
//                                     Print
//                                 </Button>
//                             </Grid>
//                         </Grid>
//                     </Grid>
//                     <Grid item xs={3}>
//                         <TextField
//                             fullWidth
//                             size='small'
//                             placeholder='Search service provider'
//                             InputProps={{
//                                 endAdornment: <InputAdornment><Search /></InputAdornment>
//                             }}
//                             onChange={e => setsearchQuery(e.currentTarget.value)}
//                         />
//                     </Grid>
//                 </Grid>
//                 {/* data */}
//                 <Grid item xs={12} style={{ minHeight: '100%' }}>
//                     <DataGrid
//                         className='datagrid'
//                         rows={searchData}
//                         columns={columns}
//                         rowHeight={50}
//                         getRowClassName={() => 'row'}
//                         showCellVerticalBorder={false}
//                         getRowId={(row) => `${row.phoneNumber}_${row.role}`}
//                         ref={pdfRef}
//                         getRowSpacing={getRowSpacing}
//                     />
//                 </Grid>
//             </Grid>
//         </Box>
//     )
// }

// export default ServiceProvider


import {
  Box,
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography
} from "@mui/material";
import React, { useContext, useRef, useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import User from "../services/db/user";
import objToXlsx from "../utils/objToXlsx";
import htmlToPdf from "../utils/htmlToPdf";
import { InfoContext } from "../services/Context/Info/context";
import { Search } from "@mui/icons-material";
import search from "../utils/searchEngine";
import { Link } from "react-router-dom";

function formatDate(date) {
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yy = String(date.getFullYear()).slice(-2);
  return `${dd}-${mm}-${yy}`;
}

const columns = [
  { field: "displayName", headerName: "Name", width: 150 },
  { field: "displayName", headerName: "User Name", width: 150 },
  {
    field: "createdAt",
    headerName: "Date Register",
    width: 150,

    // Convert Firestore timestamp to Date object for sorting
    valueGetter: (params) => {
      const createdAt = params.row.createdAt;

      if (!createdAt) return null;

      // Firestore Timestamp instance
      if (typeof createdAt.toDate === "function") {
        return createdAt.toDate();
      }

      // Raw seconds/nanoseconds object
      if (createdAt.seconds) {
        return new Date(
          createdAt.seconds * 1000 + (createdAt.nanoseconds || 0) / 1e6
        );
      }

      return null;
    },

    // Display formatted date
    valueFormatter: (params) => {
      if (!params.value) return "";
      return formatDate(params.value);
    },

    // Compare Date objects
    sortComparator: (v1, v2) => {
      if (!v1 || !v2) return 0;
      return v1.getTime() - v2.getTime();
    }
  },
  { field: "email", headerName: "Email id", width: 250 },
  { field: "phoneNumber", headerName: "Contact Number", width: 150 },
  { field: "category", headerName: "Services", width: 150 },
  {
    field: "action",
    headerName: "Action",
    renderCell: ({ row }) => {
      return (
        <Button
          size="small"
          variant="contained"
          LinkComponent={Link}
          to={`/service-provider/${row.phoneNumber}_${row.role}_${row.uid}`}
        >
          View
        </Button>
      );
    }
  }
];

const ServiceProvider = () => {
  const pdfRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState();
  const {
    data: { serviceProviderData },
    setData
  } = useContext(InfoContext);

  useEffect(() => {
    if (!serviceProviderData.length) {
      new User().allServiceProviders().then((r) => {
        setData((p) => ({ ...p, serviceProviderData: r }));
      });
    }
  }, []);

  const searchData = search(searchQuery, serviceProviderData, [
    "displayName",
    "email",
    "phoneNumber"
  ]);

  const getRowSpacing = React.useCallback((params) => {
    return {
      top: params.isFirstVisible ? 0 : 5,
      bottom: params.isLastVisible ? 0 : 5
    };
  }, []);

  const commonButtonProps = {
    variant: "contained",
    size: "medium",
    color: "primary",
    fullWidth: true
  };

  return (
    <Box sx={{ paddingX: 5, height: "100%" }}>
      <Grid
        container
        direction="column"
        paddingTop={2}
        spacing={5}
        minHeight="100%"
      >
        <Grid item xs={12} paddingY={1}>
          <Typography>Service Provider</Typography>
        </Grid>
        <Grid item container xs={12} spacing={2}>
          <Grid item container xs={9} spacing={2}>
            <Grid item xs={12} container spacing={1}></Grid>
            <Grid item xs={12} container spacing={1}>
              <Grid item xs={3}>
                <Button
                  onClick={() =>
                    objToXlsx(serviceProviderData, "serviceProvider")
                  }
                  {...commonButtonProps}
                >
                  Excel
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  onClick={() =>
                    htmlToPdf(pdfRef.current, "serviceProvider", "save")
                  }
                  {...commonButtonProps}
                >
                  PDF
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  onClick={() =>
                    htmlToPdf(pdfRef.current, "serviceProvider", "view")
                  }
                  {...commonButtonProps}
                >
                  Print
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search service provider"
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <Search />
                  </InputAdornment>
                )
              }}
              onChange={(e) => setSearchQuery(e.currentTarget.value)}
            />
          </Grid>
        </Grid>

        {/* Data Grid */}
        <Grid item xs={12} style={{ minHeight: "100%" }}>
          <DataGrid
            className="datagrid"
            rows={searchData}
            columns={columns}
            rowHeight={50}
            getRowClassName={() => "row"}
            showCellVerticalBorder={false}
              getRowId={(row) => row.uid || row.id} 
            // getRowId={(row) => `${row.phoneNumber}_${row.role}`}
            ref={pdfRef}
            getRowSpacing={getRowSpacing}
            initialState={{
              sorting: {
                sortModel: [{ field: "createdAt", sort: "asc" }] 
              }
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ServiceProvider;
